/**
 * Formats a number to display with K for thousands and M for millions
 * with a maximum of 1 decimal place
 * @param num The number to format
 * @returns Formatted string
 */
export const formatViewCount = (num?: number): string => {
  if (num === undefined || num === null) return "0";

  if (num >= 1000000) {
    // Format as millions (M)
    return (Math.floor(num / 100000) / 10).toFixed(1).replace(/\.0$/, "") + "M";
  } else if (num >= 1000) {
    // Format as thousands (K)
    return (Math.floor(num / 100) / 10).toFixed(1).replace(/\.0$/, "") + "K";
  } else {
    // Return as is for numbers less than 1000
    return num.toString();
  }
};

/**
 * Formats a date to show "Today", "Yesterday" or "X days ago"
 * @param dateString The date string to format
 * @returns Formatted string
 */
export const formatLastUsedDate = (dateString?: string): string => {
  if (!dateString) return "";

  const date = new Date(dateString);
  const today = new Date();

  // Normalize both to local midnight (remove time portion)
  const dateMidnight = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());

  const diffTime = todayMidnight.getTime() - dateMidnight.getTime();
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return "Today";
  if (diffDays === 1) return "Yesterday";
  if (diffDays > 1) return `${diffDays} days ago`;

  return "Today"; // future dates fallback
};
